import Vue from 'vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import TextInput from '../../component/dccore-form/textInput.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'

if ($('#warehouse_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#warehouse_form',
    components: {
      RingLoader,
      TextInput,
      Singleselect,
      Checkbox,
      Multiselect
    },
    mixins: [mixins],
    data: {
      loading: 0,
      form: {
        entity: {
          team: null,
          supplyTeams: [],
          deliveryAddress: null,
          selectedSupplyTeams: [],
          supply: false,
        },
        options: {
          supplyTeams: [],
          teams: [],
          deliveryAddresses: [],
          errors: {},
        }
      },
      allTeams: [],
      entityId: null,
    },
    watch: {
      'form.entity.isVirtual': function () {
        this.getTeams(this.form.entity.isVirtual)
      },
      'form.entity.supply': function () {
        this.getSupplyTeams()
      },
    },
    mounted: function () {
      if ($('#entity_id').length) {
        this.entityId = $('#entity_id').val()
        this.getWarehouse()
      }
      this.getTeams()
      this.getDeliveryAddresses()
    },
    methods: {
      createWarehouse: function (redirect) {
        let url = Routing.generate('api_post_warehouse')
        this.$http.post(url, {
          'data': this.form.entity,
        }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('warehouse_grid'))
          } else {
            toastr.success(Translator.trans('warehouse.create.created'))
            this.form.options.errors = {}
          }
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
      },
      updateWarehouse: function (redirect) {
        let url = Routing.generate('api_patch_warehouse', { id: this.entityId })

        this.$http.patch(url, {
          'data': this.form.entity
        }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('warehouse_grid'))
          } else {
            toastr.success(Translator.trans('warehouse.update.updated'))
            this.form.options.errors = {}
          }
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
      },
      getWarehouse: function () {
        let url = Routing.generate('api_get_warehouse', { id: this.entityId,
          context: 'edit' })

        Vue.http.get(url).then(response => {
          this.form.entity = response.data
          let supplyTeams = response.data.supplyTeams.map(team => team.id)
          this.form.entity.suppplyTeams = supplyTeams
          this.form.entity.selectedSupplyTeams = supplyTeams
          if (response.data.supply) {
            this.getSupplyTeams()
          }
        }, response => {
          this.handleAjaxError(response)
        })
      },
      remove(id) {
        let url = Routing.generate('api_remove_warehouse', { id: id })

        Vue.http.get(url).then(() => {
          toastr.success(Translator.trans('form.removed'))
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getTeams(avoidVirtual) {
        let url = Routing.generate('api_get_warehouse_allowed_teams', {
          warehouse: this.entityId,
          avoidVirtual: avoidVirtual & 1
        })

        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.teams = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getSupplyTeams() {
        let url = Routing.generate('api_get_active_production_teams')

        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.supplyTeams = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getDeliveryAddresses() {
        let url = Routing.generate('api_get_tags', { type: 'delivery_address',
          context: 'dropdown' })

        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.deliveryAddresses = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
    }

  })
}
